var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatePan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 7.83325H14.8332V6.16658H10.6665V7.83325ZM10.6665 5.33325H14.8332V3.66659H10.6665V5.33325ZM3.1665 10.3333H9.83317V9.87492C9.83317 9.24992 9.52761 8.75353 8.9165 8.38575C8.30539 8.01797 7.49984 7.83381 6.49984 7.83325C5.49984 7.8327 4.69428 8.01686 4.08317 8.38575C3.47206 8.75464 3.1665 9.25103 3.1665 9.87492V10.3333ZM6.49984 6.99992C6.95817 6.99992 7.35067 6.83686 7.67734 6.51075C8.004 6.18464 8.16706 5.79214 8.1665 5.33325C8.16595 4.87436 8.00289 4.48214 7.67734 4.15659C7.35178 3.83103 6.95928 3.6677 6.49984 3.66659C6.04039 3.66547 5.64817 3.82881 5.32317 4.15659C4.99817 4.48436 4.83484 4.87659 4.83317 5.33325C4.8315 5.78992 4.99484 6.18242 5.32317 6.51075C5.6515 6.83909 6.04373 7.00214 6.49984 6.99992ZM2.33317 13.6666C1.87484 13.6666 1.48262 13.5035 1.1565 13.1774C0.830393 12.8513 0.667059 12.4588 0.666504 11.9999V1.99992C0.666504 1.54159 0.829837 1.14936 1.1565 0.823252C1.48317 0.497141 1.87539 0.333808 2.33317 0.333252H15.6665C16.1248 0.333252 16.5173 0.496585 16.844 0.823252C17.1707 1.14992 17.3337 1.54214 17.3332 1.99992V11.9999C17.3332 12.4583 17.1701 12.8508 16.844 13.1774C16.5179 13.5041 16.1254 13.6671 15.6665 13.6666H2.33317Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePan);
export default __webpack_public_path__ + "static/media/update-pan.cc5bb490524fda26758db9f268126d64.svg";
export { ForwardRef as ReactComponent };